mutation DeleteUser($id: ID!) {
  deleteUser(input: { id: $id }) {
    success
  }
}
